import format from '../utils/format'

const commonHeaders = process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}

export default fetch => ({
  getList (
    conditions, // Name, CountryCode, IsMore
    loading // (isLoading: boolean) => void
  ) {
    // console.log(conditions)
    if (conditions.CreditBlock === -1) {
      delete conditions.CreditBlock
    }

    return fetch({
      url: '/api/v1/order/orderlist',
      data: {
        PageSize: conditions.PageSize,
        PageIndex: conditions.PageIndex,
        IsPageView: conditions.IsPageView,
        OrderQueryParas: {
          CustomerNumber: conditions.CustomerNumber,
          OrderNumber: conditions.OrderNumber,
          OrderStatus: conditions.OrderStatus || null,
          CustomerOrderNumber: conditions.CustomerOrderNumber,
          Mlfb: conditions.Mlfb,
          SPRNumber: conditions.SPRNumber,
          EmployeeName: conditions.EmployeeName,
          StartDate: conditions.range.from
            ? format(new Date(conditions.range.from), 'date', '/')
            : null,
          EndDate: conditions.range.to
            ? format(new Date(conditions.range.to), 'date', '/')
            : null,
          CreditBlock: conditions.CreditBlock
        }
      },
      headers: commonHeaders,
      loading
    }).then(res => {
      if (res) return res.OrderSet
    })
  },

  getDetail (OrderNumber, loading) {
    return fetch({
      url: '/api/v1/order/orderdetail',
      data: { OrderNumber },
      headers: commonHeaders,
      loading
    })
  },

  getPreciseList (
    conditions, // Name, CountryCode, IsMore
    loading // (isLoading: boolean) => void
  ) {
    // console.log(conditions)
    conditions.CreditBlock = !!conditions.CreditBlock

    return fetch({
      url: '/api/v1/order/ordermatchlist',
      data: {
        PageSize: conditions.PageSize,
        PageIndex: conditions.PageIndex,
        IsPageView: conditions.IsPageView,
        OrderQueryMatchParas: {
          CustomerNumber: conditions.CustomerNumber,
          OrderNumber: conditions.OrderNumber,
          OrderStatus: conditions.OrderStatus || null,
          CustomerOrderNumber: conditions.CustomerOrderNumber,
          Mlfb: conditions.Mlfb,
          SPRNumber: conditions.SPRNumber,
          EmployeeName: conditions.EmployeeName,
          StartDate: conditions.range.from
            ? format(new Date(conditions.range.from), 'date', '/')
            : null,
          EndDate: conditions.range.to
            ? format(new Date(conditions.range.to), 'date', '/')
            : null,
          CreditBlock: conditions.CreditBlock
        }
      },
      headers: commonHeaders,
      loading
    }).then(res => {
      if (res) return res.OrderSet
    })
  },

  getMaterials (OrderNumber, loading) {
    return fetch({
      url: '/api/v1/order/orderitem',
      data: { OrderNumber },
      headers: commonHeaders,
      loading
    })
  },

  getDelivery (OrderNumber, OrderItem, loading) {
    return fetch({
      url: '/api/v1/order/orderdelivery',
      data: { OrderNumber, OrderItem },
      headers: commonHeaders,
      loading
    })
  },

  getInvoice (OrderNumber, OrderItem, loading) {
    return fetch({
      url: '/api/v1/order/orderinvoice',
      data: { OrderNumber, OrderItem },
      headers: commonHeaders,
      loading
    })
  },

  getLogistics (DeliveryNumber, loading) {
    return fetch({
      url: '/api/v1/order/logisticstracking',
      data: { DeliveryNumber },
      headers: commonHeaders,
      loading
    })
  },

  getStockUpdateDate (loading) {
    return fetch({
      url: '/api/v1/stock/getstockupdatedate',
      method: 'GET',
      headers: commonHeaders,
      loading
    }).then(res => {
      if (res && res.StockUpdateDate) return res.StockUpdateDate
    })
  },

  getStock (conditions, loading) {
    return fetch({
      url: '/api/v1/stock/stocklist',
      data: {
        PageSize: conditions.pageSize,
        PageIndex: conditions.pageIndex,
        StockQueryParasList: [{ material: conditions.number }]
      },
      headers: commonHeaders,
      loading
    })
  },

  getStockFuzzy (conditions, loading) {
    return fetch({
      url: '/api/v1/stock/stockfuzzylist',
      data: {
        PageSize: conditions.pageSize,
        PageIndex: conditions.pageIndex,
        StockFuzzyQueryParas: { material: conditions.number }
      },
      headers: commonHeaders,
      loading
    })
  },

  getFavorites (Username, loading) {
    return fetch({
      url: '/api/v1/favorite/GetFavoriteList',
      headers: commonHeaders,
      data: { Username },
      loading
    })
  },

  setFavorite (order, loading, errorHandlers) {
    return fetch({
      url: '/api/v1/favorite/Add',
      data: {
        orderNumber: order.order_number,
        customerName: order.cust_name,
        customerPO: order.cust_order_number,
        orderDate: order.order_date,
        order_status: order.order_status,
        creditBlock: order.CreditBlock,
        deliveryBlock: order.DeliveryBlock,
        zminBlock: order.zmin_block
      },
      headers: commonHeaders,
      loading,
      onBusinessError: errorHandlers.onBusinessError,
      onError: errorHandlers.onError,
      routerCancel: false
    })
  },

  removeFavorite (OrderNumber, loading, errorHandlers) {
    return fetch({
      url: '/api/v1/favorite/Delete',
      data: { OrderNumber },
      headers: commonHeaders,
      loading,
      onBusinessError: errorHandlers.onBusinessError,
      onError: errorHandlers.onError,
      routerCancel: false
    })
  }
})
